export class EventHostService {
    constructor($http, apexApiUrl) {
        'ngInject'
        this.$http = $http
        this.apexApiUrl = apexApiUrl
    }

    /**
     * Retrieve a list of all the event hosts.
     */
    retrieveEventHosts(query) {
        return this.$http.get(this.apexApiUrl + "v1/event-hosts/", {
            params: query,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    retrieveEventHostsPage(pageIndex, query) {
        return this.$http.get(this.apexApiUrl + "v1/event-hosts/page/" + pageIndex || 0, {
            params: query,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
    * Retrieve given event host.
    */
    retrieveEventHost(eventHostID) {
        return this.$http.get(this.apexApiUrl + "v1/event-hosts/" + eventHostID, {
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Create a new event host.
     */
    createEventHost(eventHost) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "v1/event-hosts/",
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(eventHost)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Update the given event host.
     */
    updateEventHost(eventHostID, eventHost) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "v1/event-hosts/" + eventHostID,
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify(eventHost)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Delete the given event host.
    */
    deleteEventHost(eventHostID) {
        return this.$http({
            method: "DELETE",
            url: this.apexApiUrl + "v1/event-hosts/" + eventHostID,
            headers: {
                "Content-Type": "application/json"
            }
        }).then(function (response) {
            return response.data;
        });
    }

    getEventHostTypes() {
        return [
            {
                Name: "Retailer",
                Type: "Retailer",
                HostTypeID: 1
            },
            {
                Name: "Corporation",
                Type: "Corporation",
                HostTypeID: 2
            },
            {
                Name: "Shopping Mall",
                Type: "ShoppingMall",
                HostTypeID: 3
            },
            {
                Name: "Special Event",
                Type: "SpecialEvent",
                HostTypeID: 4
            }];
    }

}
